<div  *ngFor="let item of menulist" class="navbar-container">
  <a mat-list-item [disabled]="false" [routerLink]="[{ outlets: { child1: [item.value] } }]"><h2>{{item.name}}</h2></a>
  <div *ngIf="item.sub" class="navbar-container__sub-nav">
    <a mat-list-item *ngFor="let sub of item.sub" class="navbar-container__sub-nav__items" [routerLink]=sub.value><h4>{{sub.name}}</h4></a>
  </div>
</div>
